import { render } from "./allow_ip.vue?vue&type=template&id=1febe308"
import script from "./allow_ip.vue?vue&type=script&lang=js"
export * from "./allow_ip.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__